import { ADMIN_ALLOW_LIST } from '@mote/helpers/constants'
import { noLog as log } from '../../shared/Utils'
import { getMoteLogin } from '../../shared/Auth'
import { apiClient } from '@mote/api'

function makeVIP(userId, success, failure) {
  return _makeUnmakeVIP(userId, true, success, failure)
}

function unmakeVIP(userId, success, failure) {
  return _makeUnmakeVIP(userId, false, success, failure)
}

function _request(path, payload, success, failure) {
  return apiClient
    .extend({
      timeout: 15000
    })
    .post(`x/${path}`, {
      json: payload
    })
    .then(res => res.json())
    .then(res => {
      success?.(res)
    })
    .catch(err => {
      failure?.(err)
      console.error("Couldn't parse json", err.message)
    })
}

function _makeUnmakeVIP(userId, setTo, success, failure) {
  return _request('vip', { userId, setTo }, success, failure)
}

function deleteUser(userId, success, failure) {
  return _request('deleteUser', { userId }, success, failure)
}

function freeTrialExtension(userId, weeks, success, failure) {
  return _request('trialExtension', { userId, weeks }, success, failure)
}

function searchUsers(userIdsAndEmails, success, failure) {
  log('Looking up users: ', userIdsAndEmails)

  return _request('searchUsers', { userIdsAndEmails }, success, failure)
}

function listSchools(success, failure) {
  return _request('listInstitutions', {}, success, failure)
}

function enableFallbackUnlimitedDomain(
  institutionId,
  toggle,
  success,
  failure
) {
  return _request(
    'institutionToggleUnlimited',
    { institutionId, enabled: toggle },
    success,
    failure
  )
}

function enableForcedMinorUnlimitedDomain(
  institutionId,
  toggle,
  success,
  failure
) {
  return _request(
    'institutionToggleUnlimitedForcedMinor',
    { institutionId, enabled: toggle },
    success,
    failure
  )
}

function enableForcedMinorEssentialDomain(
  institutionId,
  toggle,
  success,
  failure
) {
  return _request(
    'institutionToggleEssential',
    { institutionId, enabled: toggle },
    success,
    failure
  )
}

function enforceAdministratorOnlyAccess() {
  const loginData = getMoteLogin()
  if (
    loginData === {} ||
    !loginData.primaryEmailAddress ||
    !ADMIN_ALLOW_LIST.includes(loginData.primaryEmailAddress)
  ) {
    window.location.href =
      window.location.protocol +
      '//' +
      window.location.host +
      '/login?force=1&returnTo=/admin'
  }
}

export {
  enforceAdministratorOnlyAccess,
  searchUsers,
  makeVIP,
  unmakeVIP,
  freeTrialExtension,
  deleteUser,
  listSchools,
  enableFallbackUnlimitedDomain,
  enableForcedMinorUnlimitedDomain,
  enableForcedMinorEssentialDomain
}
